import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import { RegionService } from 'src/app/services/region.service';
import { ProService } from '../../../services/pro.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';

@Injectable()
export class MspRegionEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);
  private proService = inject(ProService);

  constructor() {}

  readMspCompany$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspActionTypes.GetMspRegions),
    map((action: featureActions.GetMspRegions) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // const param = {
      //   MspMainRegionId : payload.MspMainRegionId,
      //   otp: user.otp
      // }
      // return this.proService.ReadProCompany(param).pipe(
      const params = {
        otp: user.otp,
        MspMainRegionId: payload.MspMainRegionId
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMspCompany
      };
      return this.regionService.ReadProCompany(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.GetMspRegionSuccess(res.msg.body), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, result: res.result })];
          }
        })
      );
    })
  ));
  updateMspCompany$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspActionTypes.UpdateMspRegion),
    map((action: featureActions.UpdateMspRegion) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = { ...payload.changes, otp: user.otp };
      return this.regionService.UpdateProCompany(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.UpdateMspCompany };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateMspCompany
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  addMspCompany$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspActionTypes.AddMspRegion),
    map((action: featureActions.AddMspRegion) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const params = { ...payload, otp: user.otp };
      return this.regionService.AddProCompany(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.AddMspCompany };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddMspCompany
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  translateMspDevice$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspActionTypes.TranslateMspDevice),
    map((action: featureActions.TranslateMspDevice) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        dcodes: payload.dcodes,
        SourceRegionId: payload.SourceRegionId,
        RegionId: payload.RegionId
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.TranslateMspDevice
      };
      return this.proService.TranslateProDevice(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          if (res.result) {
            const deviceMgtParam = { syncAccountsInfo: true };
            return [new featureActions.GetDeviceMgtLists(deviceMgtParam), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            console.log('error');
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: 'error' })];
        })
      );
    })
  ));
}
